import { Component, Prop, Vue } from 'vue-property-decorator';
import { Label } from '@/store/models/label';
import label from '@/store/modules/label';
import LabelChip from '@/components/Label/Chip';
import FinderBase from '@/components/Label/Finder/Base';
import { router } from '@/_helpers/router';
import { t } from '@/i18n/i18n';
import notifier from '@/_helpers/notifier';
import noDataText from '@/_helpers/search';
import template from './Filter.vue';

@Component({
	mixins: [template],
	components: {
		LabelChip,
		FinderBase
	}
})
export default class FinderFilter extends Vue {
	@Prop({ type: String, default: 'width: 376px; max-width: 100%;' }) styleP: string;

	@Prop({ type: String, default: t('placeholders.filter-by-labels') }) placeholder: string;

	@Prop({ type: String, default: t('labels.filter-labels') }) label: string;

	@Prop({ type: Boolean, default: false }) loading: boolean;

	@Prop({
		default(): Label[] {
			return [];
		}
	})
	items: Label[];

	@Prop({}) search: (search: string) => Promise<void>;

	@Prop({ type: String, default: t('search-box.text', { type: t('search-box.types.labels') }) }) noDataText: string;

	@Prop({ type: String, default: t('hints.filter-by-labels') }) hint: string;

	@Prop({ type: Boolean, default: true }) persistance: boolean;

	@Prop() blur: () => void;

	internalLoading: boolean = false;

	keyword: string = '';

	query: any = {};

	selected: Label[] = [];

	async mounted(): Promise<void> {
		this.query = Object.assign({}, this.$route.query);
		if (this.query.labels) {
			// Will turn the comma seperated string into an array
			// Find labels and push them to the finder base

			(this.query.labels.split(',') as string[]).forEach(async (element) => {
				try {
					const labels = (await label.get(element)).data;
					(this.$refs.base as FinderBase).addChip(labels);
					this.selected.push(labels);
				} catch (err) {
					console.error(err);
				}
			});
		}
	}

	async internalSearch(search: string) {
		if (this.search !== undefined) {
			this.search(search);
		} else {
			this.internalLoading = true;
			this.keyword = search;

			const obj = { search };

			try {
				await label.getAll({ projectID: this.$route.params.Pid, query: obj });
				this.selected.forEach((element) => {
					let found: boolean = false;
					label.labels.forEach((element2: Label) => {
						if (element === element2) {
							found = true;
						}
					});

					if (!found) {
						label.labels.push(element);
					}
				});
			} catch (error) {
				notifier.error('getting', 'labels');
			} finally {
				this.internalLoading = false;
			}
		}
	}

	get labels(): Label[] {
		return label.labels;
	}

	filterOnLabel() {
		if (this.selected.length > 0) {
			this.query.labels = this.selected.map((element) => element.id).join(',');
		} else {
			delete this.query.labels;
		}

		router.push({ query: this.query });
	}

	get noResultsLabelText(): string {
		return noDataText(this.internalLoading, this.keyword, 'labels');
	}

	updateSelected(labels: Label[]): void {
		this.selected = labels;
	}
}
